import { render, staticRenderFns } from "./PatientDrugTable.vue?vue&type=template&id=658b0b9c&scoped=true"
import script from "./PatientDrugTable.vue?vue&type=script&lang=js"
export * from "./PatientDrugTable.vue?vue&type=script&lang=js"
import style0 from "./PatientDrugTable.vue?vue&type=style&index=0&id=658b0b9c&prod&lang=scss&scoped=true"
import style1 from "./PatientDrugTable.vue?vue&type=style&index=1&id=658b0b9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658b0b9c",
  null
  
)

export default component.exports